import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddBet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Icon - Betslip Add",
	viewBox: "0 0 22.8 24.374",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M5.245 5.75h9.5",
			"data-name": "Line 1585"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M5.245 9.75h8",
			"data-name": "Line 1586"
		}),
		/* @__PURE__ */ _jsx("g", {
			"data-name": "Group 4691",
			children: /* @__PURE__ */ _jsx("g", {
				"data-name": "Group 4690",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "none",
					stroke: "currentColor",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					d: "M16.7 9.75h6.099",
					"data-name": "Line 1587"
				})
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M19.75 6.7v6.099",
			"data-name": "Line 1588"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M5.245 13.75h6.5",
			"data-name": "Line 1589"
		}),
		/* @__PURE__ */ _jsx("g", {
			"data-name": "Group 4693",
			children: /* @__PURE__ */ _jsx("g", {
				"data-name": "Group 4692",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					d: "M19.749 3.75v-2a1 1 0 0 0-1-1h-17a1 1 0 0 0-1 1v20.912a.5.5 0 0 0 .82.38l4.676-2.292 3.7 2.774a.5.5 0 0 0 .6 0l3.7-2.774 4.675 2.292a.5.5 0 0 0 .825-.38v-6.887",
					"data-name": "Path 7551"
				})
			})
		})
	]
});
export { SvgAddBet as ReactComponent };
